var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluecross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bluecross") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.6713233%",
    y1: "76.5264847%",
    x2: "0%",
    y2: "21.5571321%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.6713233%",
    y1: "82.5475258%",
    x2: "0%",
    y2: "15.101106%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.6713233%",
    y1: "90.0566596%",
    x2: "0%",
    y2: "7.04948128%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#695DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B5FC",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B500",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bluecross",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-3-link",
    transform: "translate(3.000000, 4.000000)",
    fill: "url(#linearGradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0.5 C16.4519481,0.5 0.5,14.8792208 0.5,32.5 C0.5,50.1207792 16.4519481,64.5 36,64.5 C55.5480519,64.5 71.5,50.1207792 71.5,32.5 C71.5,14.8792208 55.5480519,0.5 36,0.5 Z",
    id: "path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3-link",
    fill: "#695DFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,0.5 C17.8,0.5 0.5,17.8 0.5,39 C0.5,60.2 17.8,77.5 39,77.5 C60.2,77.5 77.5,60.2 77.5,39 C77.5,17.8 60.2,0.5 39,0.5 Z M52.9,52.8 C52.4,53.3 51.8,53.5 51.1,53.5 C50.4,53.5 49.8,53.3 49.3,52.8 L39,42.5 L28.8,52.8 C28.3,53.3 27.7,53.5 27,53.5 C26.3,53.5 25.7,53.3 25.2,52.8 C24.2,51.8 24.2,50.2 25.2,49.3 L35.5,39 L25.2,28.7 C24.2,27.8 24.2,26.2 25.2,25.2 C26.1,24.2 27.7,24.2 28.7,25.2 L39,35.5 L49.3,25.2 C50.2,24.2 51.8,24.2 52.8,25.2 C53.8,26.1 53.8,27.7 52.8,28.7 L42.5,39 L52.9,49.3 C53.9,50.2 53.9,51.8 52.9,52.8 Z",
    id: "path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecross);
export default __webpack_public_path__ + "static/media/bluecross.c8b105ecab076e5bcfdb90854fd40b09.svg";
export { ForwardRef as ReactComponent };